import toBlob from 'b64-to-blob'

const parseBase64 = (base64String: string | null | undefined): string => {
  const block = (base64String || '').split(';')
  return block[1].split(',')[1]
}

export const stringToBlob = (value: string): Blob => toBlob(parseBase64(value))
